// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form[data-v-b6b7ec36] {\n  margin: 20px 0px;\n}\n.login-button[data-v-b6b7ec36] {\n  display: inline-block;\n  width: 100%;\n  height: 40px;\n  background-color: #cd0101;\n  color: white;\n  border-radius: 5px;\n  margin-top: 20px;\n}\n.captcha[data-v-b6b7ec36] {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  white-space: nowrap;\n}\n.captcha-input[data-v-b6b7ec36] {\n  width: 60%;\n}\n", ""]);
// Exports
module.exports = exports;
